import CreateCategoryModal from './CreateCategoryModal';

export default CreateCategoryModal;
